<!--  -->
<template>
<div>
    <v-container grid-list-md fluid>
        <v-layout row wrap fill-height>
            <v-card outlined class="pa-2 width-100">
                <v-sheet class="d-flex pa-2 light-bg">
                    <p class="text-color">Weekly Visit Status</p>
                    <v-spacer></v-spacer>
                </v-sheet>
                <v-progress-linear
                        :active="is_loading"
                        :indeterminate="is_loading"
                        absolute
                        color="rgb(172, 189, 200)"
                    ></v-progress-linear>
                <div class="mt-3">
                    <canvas ref="chart"></canvas>
                </div>
            </v-card>
        </v-layout>
    </v-container>
</div>
</template>

<script>
export default {
     data: () => {
        return {
            is_loading: false,
        }
     },
    mounted() {
        this.is_loading= true;
        axios.get(`${process.env.VUE_APP_API_URL}/api/dashboard/chartjs`).then((response) => {
            var res = response.data.data;

             var keys_1 = Object.keys(response.data.data);
             var count_1 = [];

            var keys = ['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday']
            var count = [0,0,0,0,0,0,0];
           
            keys_1.forEach(element => {
                 if(element =='Mon'){count[0]=response.data.data[element].length};
                 if(element =='Tue'){count[1]=response.data.data[element].length};
                 if(element =='Wed'){count[2]=response.data.data[element].length};
                 if(element =='Thu'){count[3]=response.data.data[element].length};
                 if(element =='Fri'){count[4]=response.data.data[element].length};
                 if(element =='Sat'){count[5]=response.data.data[element].length};
                 if(element =='Sun'){count[5]=response.data.data[element].length};
            });

            var chart = this.$refs.chart;
            var ctx = chart.getContext("2d");
            var myChart = new Chart(ctx, {
                type: 'bar',
                data: {
                    labels: keys,
                    datasets: [{
                        label: 'Number of Visits',
                        data: count,
                        borderWidth: 1
                    }]
                },
                options: {
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true,
                                 precision:0
                            }
                        }]
                    }
                }
            });
            this.is_loading =false;
        }).catch(error => {
            console.log(error)
            this.errored = true
        });
    }
}
</script>
